import { Injectable } from '@angular/core';
import {
  CadFileProcessingStatus,
  CadFileProcessingUpdate,
} from '../../models/cad-file.model';

@Injectable({ providedIn: 'root' })
export class CadProcessingService {
  isTerminal(update: CadFileProcessingUpdate): boolean {
    return [
      CadFileProcessingStatus.COMPLETED,
      CadFileProcessingStatus.PARTIAL_FAILURE,
      CadFileProcessingStatus.FAILED,
    ].includes(update.processing_status);
  }

  hasObjects(update: CadFileProcessingUpdate): boolean {
    return (
      update.total_object_count > 0 &&
      [
        CadFileProcessingStatus.PROCESSING,
        CadFileProcessingStatus.COMPLETED,
        CadFileProcessingStatus.PARTIAL_FAILURE,
      ].includes(update.processing_status)
    );
  }

  isFailure(update: CadFileProcessingUpdate): boolean {
    return [
      CadFileProcessingStatus.PARTIAL_FAILURE,
      CadFileProcessingStatus.FAILED,
    ].includes(update.processing_status);
  }

  progress(update: CadFileProcessingUpdate): number | null {
    if (update.processing_status === CadFileProcessingStatus.COMPLETED) {
      return 100;
    }
    if (update.total_object_count === 0) {
      return null;
    }
    return Math.round(
      ((update.completed_object_count + update.failed_object_count) /
        update.total_object_count) *
        100,
    );
  }

  statusText(update: CadFileProcessingUpdate): string {
    switch (update.processing_status) {
      case CadFileProcessingStatus.QUEUED:
        return 'Queued for processing';
      case CadFileProcessingStatus.EXTRACTING:
        return 'Reading CAD file';
      case CadFileProcessingStatus.PROCESSING:
        return update.total_object_count > 0
          ? `Generating viewer data — ${update.completed_object_count}/${update.total_object_count}`
          : 'Generating viewer data';
      case CadFileProcessingStatus.COMPLETED:
        return 'Viewer data ready';
      case CadFileProcessingStatus.PARTIAL_FAILURE:
        return update.total_object_count > 0
          ? `Viewer data generated with errors — ${update.completed_object_count}/${update.total_object_count}`
          : 'Viewer data generated with errors';
      case CadFileProcessingStatus.FAILED:
        return update.processing_error || 'CAD processing failed';
    }
  }
}
